module.exports = __webpack_public_path__ + "static/media/video_icon_h.0e966d00.png";